import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

/**
 * A IMPLEMENTER PAR LES ECRANS QUI PEUVENT CONTENIR DES DONNEES NON ENREGISTREES
 * (EXEMPLE : LA SAISIE D'INVENTAIRE PAR LOT)
 */
export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable({
  providedIn: 'root'
})
export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {
  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    return component ? component.canDeactivate() : true;
  }
}
